<ui-sidebar
    remove-host
    [menuItems]="sideBarMenuItems"
    [sidebarShowMobile]="sidebarShowMobile"
    [sidebarShowLG]="sidebarShowLG"
></ui-sidebar>
<!-- Sidebar content here -->

<div class="c-wrapper">
    <header class="c-header c-header-dark c-header-fixed">
        <button
            class="c-header-toggler c-class-toggler d-lg-none mfe-auto"
            type="button"
            data-target="#sidebar"
            data-class="c-sidebar-show"
            title="{{ (sidebarShowMobile ? 'menu.menuHide' : 'menu.menuShow') | translate }}"
            (click)="toggleMinimize($event)"
        >
            <span class="c-header-toggler-icon"></span>
        </button>
        <button
            class="c-header-toggler c-class-toggler mfs-3 d-md-down-none"
            type="button"
            responsive="true"
            title="{{ (sidebarShowLG ? 'menu.menuHide' : 'menu.menuShow') | translate }}"
            (click)="toggleSidebarLG($event)"
        >
            <span class="c-header-toggler-icon"></span>
        </button>
        <div class="alert alert-warn bg-gradient-warning" *ngIf="internaltest">INTERNA TESTOVACIA VERZIA</div>

        <ul class="c-header-nav mfs-auto mr-3">
            <li class="c-header-nav-item dropdown" dropdown>
                <a
                    class="c-header-nav-link"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="true"
                    dropdownToggle
                    (click)="(false)"
                    aria-controls="basic-link-dropdown"
                >
                    <div class="c-avatar">
                        <img class="c-avatar-img" src="assets/img/avatar.png" alt="Profil" />
                    </div>
                </a>
                <div class="dropdown-menu dropdown-menu-right pt-0" #dropdownMenu *dropdownMenu>
                    <a class="dropdown-item" href="#">
                        <i class="c-icon mfe-2 fas fa-id-card"></i>
                        {{ 'menu.profile' | translate }}
                    </a>

                    <a class="dropdown-item" (click)="logout($event)">
                        <i class="c-icon mfe-2 fas fa-sign-out-alt"></i>
                        {{ 'menu.logout' | translate }}
                    </a>
                </div>
            </li>
        </ul>

        <ui-breadcrumbs remove-host [breadcrumbAction]="breadcrumbActionFromChild"></ui-breadcrumbs>
        <!-- Header content here -->
    </header>
    <div class="c-body">
        <main class="c-main">
            <div class="container-fluid">
                <router-outlet (activate)="currentComponent = $event"></router-outlet>
            </div>
        </main>
        <footer class="c-footer">
            <span><a href="https://slovgen.sk">SlovgenDB</a> &copy; 2020 SlovgenDB.</span>
            <!-- <span class="ml-auto">Made by <a href="https://binarytale.com">BinaryTale</a></span> -->
            <!-- Footer content here -->
        </footer>
    </div>
</div>

<div class="c-sidebar-backdrop c-fade c-show" *ngIf="sidebarBackdrop" (click)="backdropClick($event)"></div>
